import restClient from 'Shared/hooks/restClient'
import dashboard from './dashboard'

const actionSlices = {
  dashboard,
}

export default () => {
  const dis = useDis()
  const store = useStore()

  return useMemo(
    () => _.mapValues(actionSlices, (fn) => {
      return fn(dis, store, restClient)
    }),
    []
  )
}
